// **********************************************************
// Sticky Image Text Slider Work
// **********************************************************
const militaryVehiclesVideo = document.querySelectorAll('.military-vehicles-video');
militaryVehiclesVideo.forEach((el) => {
  let controllerMilitaryVehiclesVideo = null;
  controllerMilitaryVehiclesVideo = new ScrollMagic.Controller();
  const parentElement = el.closest('.sc-military-vehicles-video');
  const accordionTitles = parentElement.querySelectorAll('.military-vehicles-video__accordion-title');
  const fakeSlides = parentElement.querySelectorAll('.military-vehicles-video__faker-slide');
  const paginationBullets = parentElement.querySelectorAll('.slider-pagination__bullet');
  const videoParent = parentElement.querySelector('.military-vehicles-video__video');
  const stickyElement = parentElement.querySelector('.military-vehicles-video__sticky-body');
  const fakeSlidesWrapper = parentElement.querySelector('.military-vehicles-video__faker-slides');
  const stickyStartPoint = parentElement.querySelector('.military-vehicles-video__animation-start');
  const accordions = parentElement.querySelectorAll('.military-vehicles-video__accordion-item');
  const scrollableContainer = parentElement.querySelector('.military-vehicles-video__accordion');
  const scrollableContainerHeight = scrollableContainer.clientHeight;

  // Sticky Image Text Animations
  const initStickyElementScene = () => {
    const moveContainer = new TimelineMax();
    moveContainer.fromTo(
      scrollableContainer,
      1,
      { y: '100px' },
      { y: `-${scrollableContainerHeight / 1.5}px`, ease: 'linear' },
    );

    // Sticky scene
    const scene = new ScrollMagic.Scene({
      triggerElement: stickyStartPoint,
      duration: `${fakeSlidesWrapper.clientHeight}px`,
      triggerHook: 0,
    })
      .setTween(moveContainer)
      .setPin(stickyElement)
      .addTo(controllerMilitaryVehiclesVideo);

    if (isLocal()) {
      scene.addIndicators({ name: 'Sticky' });
    }
  };

  const toggleItems = (element, toggle, i, bullet) => {
    element[i].classList.toggle('is-open', toggle);
    bullet[i].classList.toggle('is-active');
  };

  /**
   * @typedef {Object} videoState
   * @property {HTMLVideoElement} videoElement
   * @property {Array} sections
   * @property {Object} currentSection
   * @property {Function} getCurrentTime
   */
  const videoState = {
    videoElement: null,
    sections: [],
    currentSection: null,
    fadeoutTimeoutId: null,
    fadeinTimeoutId: null,
    getCurrentTime: () => videoState.videoElement.currentTime,
    isPlaying: () =>
      !!(
        videoState.videoElement.currentTime > 0 &&
        !videoState.videoElement.paused &&
        !videoState.videoElement.ended &&
        videoState.videoElement.readyState > 2
      ),
  };

  const formatVideoTime = (time) => parseFloat(time.replace(',', '.'));

  const onVideoTimeUpdate = () => {
    const { videoElement, currentSection } = videoState;

    if (videoState.isPlaying() && videoState.getCurrentTime() >= currentSection?.endTime) {
      // videoElement.currentTime = currentSection.endTime;
      videoElement.pause();
    }

    window.requestAnimationFrame(onVideoTimeUpdate);
  };

  const playVideoUntilTime = (index) => {
    videoState.currentSection = videoState.sections[index];
    const { videoElement, currentSection, fadeoutTimeoutId, fadeinTimeoutId } = videoState;

    // Clear any existing timeouts, this will make the animation smoother
    clearTimeout(fadeoutTimeoutId);
    clearTimeout(fadeinTimeoutId);

    // Fade out the video
    videoElement.classList.toggle('fade-out', true);

    // Set it to the start time of the current section
    videoState.fadeoutTimeoutId = setTimeout(() => (videoElement.currentTime = currentSection.startTime), 300);

    // Fade it back in and play it
    videoState.fadeinTimeoutId = setTimeout(() => {
      videoElement.classList.toggle('fade-out', false);
      videoElement.play();
    }, 600);
  };

  const initVideo = () => {
    const firstSection = videoState.sections[0];

    if (firstSection) {
      videoState.currentSection = firstSection;
      videoState.videoElement.currentTime = firstSection.startTime;
      videoState.videoElement.play();
      window.requestAnimationFrame(onVideoTimeUpdate);
    }
  };

  const openAccordion = (element) => {
    gsap.to(element, { height: 'auto', duration: 0.3 });
  };

  const closeAccordion = (element) => {
    gsap.to(element, { height: '0', duration: 0.3 });
  };

  const closeAllAccordions = () => {
    const allAccordions = el.querySelectorAll('.military-vehicles-video__accordion-item.is-open');
    allAccordions.forEach((accordion) => {
      closeAccordion(accordion.querySelector('.military-vehicles-video__accordion-text'));
    });
  };

  videoState.videoElement = parentElement.querySelector('video');

  fakeSlides.forEach((slideElem) => {
    videoState.sections.push({
      startTime: formatVideoTime(slideElem.getAttribute('data-start-time')),
      endTime: formatVideoTime(slideElem.getAttribute('data-end-time')),
    });
  });

  initVideo();

  const initEachSlideScene = () => {
    fakeSlides.forEach((slideElem, i) => {
      const content = accordions[i].querySelector('.military-vehicles-video__accordion-text');
      const prevIndex = i - 1;
      const nextIndex = i + 1;

      const scene = new ScrollMagic.Scene({
        triggerElement: slideElem,
        duration: slideElem.clientHeight,
        triggerHook: 0,
      })
        .on('enter', (e) => {
          const nextItem = accordions[nextIndex];
          const prevItem = accordions[prevIndex];

          if (e.scrollDirection === 'FORWARD' && i > 0) {
            toggleItems(accordions, true, i, paginationBullets);
            openAccordion(content);
          }

          if (e.scrollDirection === 'REVERSE' && i < accordions.length - 1) {
            closeAllAccordions();
            toggleItems(accordions, true, i, paginationBullets);
            openAccordion(content);
          }

          nextItem?.classList.add('next-item');
          prevItem?.classList.add('prev-item');
          videoParent.classList.add('show-video');

          playVideoUntilTime(i);
        })
        .on('leave', (e) => {
          const nextItem = accordions[nextIndex];
          const prevItem = accordions[prevIndex];

          if (e.scrollDirection === 'FORWARD' && i < accordions.length - 1) {
            closeAllAccordions();
            toggleItems(accordions, false, i, paginationBullets);
            closeAccordion(content);
          }

          if (e.scrollDirection === 'REVERSE' && i > 0) {
            toggleItems(accordions, false, i, paginationBullets);
            closeAccordion(content);
          }

          nextItem?.classList.remove('next-item');
          prevItem?.classList.remove('prev-item');
          videoParent.classList.remove('show-video');
        })
        .addTo(controllerMilitaryVehiclesVideo);

      if (isLocal()) {
        scene.addIndicators({ name: `slide ${i}` });
      }
    });
  };

  const initAllScenes = () => {
    initStickyElementScene();
    initEachSlideScene(fakeSlides, accordions, parentElement);
  };

  const handleResize = () => {
    initializeOrDestroyScrollMagic(controllerMilitaryVehiclesVideo, initAllScenes);
  };

  if (windowWidth() >= breakpointMd) {
    initAllScenes();
  }

  window.addEventListener('resize', handleResize);

  const scrollToDiv = (element, scrollBehavior) => {
    const elementRect = element.getBoundingClientRect();
    const scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    const topOffset = elementRect.top + scrollTop;
    window.scrollTo({
      top: topOffset + 1,
      behavior: scrollBehavior,
    });
  };

  // Open item on click of title
  accordionTitles.forEach((title) => {
    title.addEventListener('click', (el) => {
      el.preventDefault();
      const itemIndex = el.target.getAttribute('data-item');
      const targetSlide = fakeSlides[itemIndex];
      scrollToDiv(targetSlide, 'smooth');
    });
  });

  // Mobile Slider
  const sliderElem = el.querySelector('[data-slider="vehicles-video__slider-init"]');

  const eventsSliderOptions = {
    slidesPerView: 1,
    spaceBetween: 18,
    speed: 800,
    watchOverflow: true,
    autoHeight: true,
    pagination: {
      el: parentElement.querySelector('.swiper-pagination'),
      clickable: true,
    },
    navigation: {
      prevEl: parentElement.querySelector('.swiper-button-prev'),
      nextEl: parentElement.querySelector('.swiper-button-next'),
    },
  };

  const vehiclesVideoSlider = new Swiper(sliderElem, eventsSliderOptions);

  vehiclesVideoSlider.on('slideChange', (swiper) => {
    const slideIndex = swiper.realIndex;
    playVideoUntilTime(slideIndex);
  });
});
